import { css, SerializedStyles } from '@emotion/react';
import { tokens, applyFont } from '@domain-group/fe-brary';

const { colors, spacing, typography } = tokens;

export const optionContent = css`
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const option = css`
  ${applyFont(typography.body)}
  min-width: 0;
  flex-grow: 1;
  line-height: 24px;
`;

export const icon = css`
  flex-shrink: 0;
  height: 32px;
  width: 32px;
  margin-right: ${spacing.s};

  svg {
    display: block;
    height: 32px;
    width: 32px;
  }
`;

export const iconV5 = css`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border-radius: ${spacing.xs};
  background-color: ${colors.neutral.subdued.default};
  margin-right: ${spacing.s};
  overflow: hidden;

  & > svg {
    display: block;
    height: 24px;
    width: 24px;
    color: ${colors.secondary.trim.hover};
  }
`;

export const iconV5Location = css`
  && {
    color: ${colors.neutral.heavy.default};
  }
`;

export const iconV5AvatarFill = css`
  height: 100%;
  width: 100%;

  & > * {
    height: 100%;
    width: 100%;
  }
`;

export const agencyLogoTile = (
  backgroundColour?: string,
): SerializedStyles => css`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${spacing.xs};
  background-color: ${backgroundColour ?? colors.neutral.subdued.default};
  outline: 0.5px solid ${colors.neutral.trim.default};
  outline-offset: -0.5px;
`;

export const agencyLogo = css`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: ${tokens.spacing.xxs};
`;

export const iconV5AgentFilledWrapper = css`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const iconV5AgentFilledFill = css`
  && {
    height: 32px;
    width: auto;
    color: ${colors.secondary.trim.hover};
  }
`;

export const name = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const optionCategory = css`
  display: block;
  ${applyFont(typography.mini)}
  color: ${colors.neutral.medium.default};
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 1px;
`;

export const optionItemHighlightText = (
  highlighted: boolean,
): SerializedStyles => css`
  ${!highlighted &&
  css`
    ${applyFont(typography.bodyBold)}
  `};
`;
